import { createSelector } from 'reselect';

import { ICoreState } from '@crm-package/app';
import { getDictionaryByNameSelector } from '@crm-package/dictionaries';

import { getBusinessUnitsAvailableForUser } from '../business-unit/selectors';

import {
  getEnvironmentsSortByFriendlyNameHelper,
  getEnvironmentsWithBusinessUnitsHelper,
} from './selectorHelpers';

export const getDefaultEnvironment = createSelector(
  (state: ICoreState) => getDictionaryByNameSelector(state, 'environment'),
  (environments) =>
    environments.find(
      (environment) =>
        environment.name === '' || environment.name === '(default)'
    )!
);

export const getEnvironmentsSortByFriendlyName = createSelector(
  (state: ICoreState) => getDictionaryByNameSelector(state, 'environment'),
  (environments) => getEnvironmentsSortByFriendlyNameHelper(environments)
);

export const getEnvironmentsWithBusinessUnits = createSelector(
  getEnvironmentsSortByFriendlyName,
  getBusinessUnitsAvailableForUser,
  (environments, businessUnits) =>
    getEnvironmentsWithBusinessUnitsHelper(environments, businessUnits)
);
